import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Header, Input, Segment, Table } from 'semantic-ui-react';
import { toast } from 'react-semantic-toasts';
import request from '../../../../utils/request';
import tableStyles from '../../../../styles/table.module.scss';
import DeleteAction from '../../../../components/admin/DeleteAction';
import Pagination from '../../../../components/admin/Pagination';

const { Cell, HeaderCell, Row} = Table;
let timer = 0;

class AdminTagsListView extends React.Component
{
    state = {
        isLoading: false,
        query: '',
        pagination: {},
        tags: [],
        confirmDelete: false,
    };

    /**
     * Mount
     */
    componentDidMount = () => {
        this.fetch();
    }

    /**
     * Delete tag
     */
    deleteTag = (tag) => {
        request.delete(`admin/tags/${tag.id}`).then(() => {
            this.fetch();

            toast({
                type: 'success',
                icon: '',
                description: 'Tag deleted succesfully',
                time: 2500,
            });
        });
    }

    /**
     * Fetch
     */
    fetch = () => {
        request(`admin/tags?q=${this.state.query}`).then(({ data }) => {
            this.setState({
                isLoading: false,
                pagination: data.meta,
                tags: data.data,
            });
        });
    }

    /**
     * Search
     */
    searchTags = (query) => {
        clearTimeout(timer);

        this.setState({
            isLoading: true,
            query,
        });

        timer = setTimeout(() => { this.fetch(); }, 300);
    }

    // --- render
    render() {
        const { isLoading, pagination, query, tags } = this.state;

        return (
            <Container className="admin-page">
                <Segment padded>
                    <div className="admin-page-header">
                        <Header as="h1">Tags</Header>
                        <Link to="/admin/tags/create">
                            <Button primary icon="plus" />
                        </Link>
                    </div>
                    <Input
                        fluid
                        loading={isLoading}
                        placeholder='Search...'
                        onChange={(e) => { this.searchTags(e.target.value); }}
                        value={query}
                    />
                    <Table>
                        <Table.Header>
                            <Row>
                                <HeaderCell>Tag</HeaderCell>
                                <HeaderCell singleLine textAlign="right">Actions</HeaderCell>
                            </Row>
                        </Table.Header>
                        <Table.Body>
                            {tags.map((tag) => (
                                <Row key={tag.id}>
                                    <Cell>
                                        <Link to={`/admin/tags/${tag.id}`}>
                                            {tag.name}
                                        </Link>
                                    </Cell>
                                    <Cell collapsing textAlign="right">
                                        <Link to={`/admin/tags/${tag.id}`}>
                                            <Button
                                                basic
                                                size="mini"
                                                icon="pencil"
                                            />
                                        </Link>
                                        <span className={tableStyles.actionsDivider}> | </span>
                                        <DeleteAction
                                            message="Are you sure you want to delete this tag?"
                                            onDelete={() => { this.deleteTag(tag); }}
                                        />
                                    </Cell>
                                </Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Segment>
                <Pagination data={pagination} onClick={this.fetch} />
            </Container>
        );
    }
}

export default AdminTagsListView;
